import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56b7f96b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TAtividades__Controle" }
const _hoisted_2 = { class: "TAtividade__Botoes p-buttonset" }
const _hoisted_3 = { class: "CalendarioDeAtividades__PeriodoAtual" }
const _hoisted_4 = { class: "TAtividades__Acoes" }
const _hoisted_5 = {
  key: 0,
  class: "TAtividades__SeletorSuperior"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-folder" }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "TAtividades__SeletorSuperior"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-map" }, null, -1))
const _hoisted_9 = { class: "OFiltroOcorrencias" }
const _hoisted_10 = { class: "OFiltroOcorrencias__Divergente" }
const _hoisted_11 = { class: "OFiltroOcorrencias__NaoDivergente" }
const _hoisted_12 = { class: "OFiltroOcorrencias__Legenda" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-exclamation-triangle" }, null, -1))

import { LCalendario } from "@/layouts"
  import SplitButton from "primevue/splitbutton"
  import PButton from "primevue/button"
  import Dropdown from "primevue/dropdown"
  import {
    MCheckbox,
    OTrilhaDeNavegacao,
    OArvoreDeSelecoes,
    ChaveValor,
    MEntradaDeBusca,
    MMultiSelect,
    MDropdown,
  } from "@/components/Gerais"
  import {
    OCalendario,
    OTravarPeriodo,
    OCriarEvento,
    OCriarEventoPlanejado,
    ODetalhesEventoPlanejado,
    ODetalhesEvento,
    OModalExcluirAtividade,
    OEditarPlanejamentoAtividade,
    OIniciarAtividadeRealizadaNaoPlanejada,
  } from "@/components/Calendario"
  import {
    TAtividades,
    OCriarRelatorioAtividades,
  } from "@/components/Atividades"
  import { MenuItem } from "primevue/menuitem"
  import TabMenu from "primevue/tabmenu"
  import {
    Ref,
    computed,
    onBeforeMount,
    onUnmounted,
    reactive,
    ref,
    watch
  } from "vue"
  import { usarListarAtividadesStore } from "@/store/atividades/ListarAtividades/ListarAtividades.store"
  import {
    FinalizarAtividadePlanejada,
    IniciarAtividadeRealizada,
  } from "@/repositorios/atividades/atividades.modelos"
  import { usarDebounces } from "@/composable/UsarDebounces/usarDebounces"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { storeToRefs } from "pinia"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"
  import {
    ModeloEventoCalendarioEmAndamento,
    ModeloEventoCalendarioPodeSerIniciada,
    VariacoesModeloEventoCalendario,
  } from "@/store/atividades"
  import AtividadesRealizadasRepositorio from "@/repositorios/atividades/atividades.repositorio"
  import { EntidadeGenerica } from "@/types/gerais"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import {
    CalendarioAdministrador,
    CalendarioSupervisor,
    CalendarioPessoal,
    CalendarioVisualizador,
    UTILIZAR_CACHE,
    NAO_UTILIZAR_CACHE,
    usuarioPossuiProfissionalAtivo,
  } from "@/paginas/Atividades/CalendarioDeAtividades/CalendarioDeAtividades.script"
  import type {
    Ocorrencias,
    CalendarioInterface,
    NomeDosModulos,
  } from "@/paginas/Atividades/CalendarioDeAtividades/CalendarioDeAtividades.modelos"
  import { cancelamento } from "@/http/cancelar/cancelar.services"
  import { usarEventosPlanejadosStore } from "@/store/atividades/EventosPlanejados/EventosPlanejados.store"
  import { EventReadyChanged, ModosDeVisualizacao } from "vue-cal"
  import { usarFiltrosDoCalendarioStore } from "@/store/atividades/filtrosDoCalendario/filtrosDoCalendario.store"
  import { usarProjetosStore } from "@/store/projetos/projetos.store"
  import { usarOcorrenciasDoCalendarioStore } from "@/store/atividades/ocorrencias/ocorrencias.store"
  import SessaoServico from "@/servicos/sessao.service"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { useI18n } from "vue-i18n"
  import { CaracteristicaStore } from "@/store/atributos/caracteristicas/caracteristicas.store"

  interface Props {
    destinoModal?: string
  }

  type PeriodoDeTempo = {
    inicial: {
      dia: number
      mes: number
      ano: number
    }
    final: {
      dia: number
      mes: number
      ano: number
    }
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarioDeAtividades',
  props: {
    destinoModal: null
  },
  setup(__props: any) {

  const { t } = useI18n()

  const { escritor, resolver } = usarEscritorDeDados()

  const atividadesRealizadasRep = new AtividadesRealizadasRepositorio()

  const escritorIniciarAtividadePlanejada = escritor<
    { id: string },
    IniciarAtividadeRealizada
  >(atividadesRealizadasRep.iniciarAtividadeRealizada, [])
  const escritorFinalizarAtividadePlanejada = escritor<
    { id: string },
    string,
    FinalizarAtividadePlanejada
  >(atividadesRealizadasRep.finalizarAtividadePlanejada, [])

  const { filtrosSelecionados } = storeToRefs(usarFiltrosDoCalendarioStore())
  const { filtrarDadosDoCalendario, limparFiltrosSelecionados } =
    usarFiltrosDoCalendarioStore()
  const { verificarSeElementoTemConteudo } = usarManipuladorObjetos()
  const caracteristicaStore = CaracteristicaStore()
  const { caracteristicas } = storeToRefs(caracteristicaStore)
  const eventosPlanejadosStore = usarEventosPlanejadosStore()
  const { limparAtividades } = usarListarAtividadesStore()
  const { atividades } = storeToRefs(usarListarAtividadesStore())
  const { projetosEntidadeGenerica: projetos, estaCarregandoProjetos } =
    storeToRefs(usarProjetosStore())
  const { ocorrencias } = storeToRefs(usarOcorrenciasDoCalendarioStore())
  const { limparOcorrencias } = usarOcorrenciasDoCalendarioStore()

  const indexAtivo = ref<number>(0)
  const itensTabMenu: MenuItem[] = [
    { label: t('filtros') },
    { label: t('ocorrencias') },
  ]

  

  const dataAtual = ref<Date>(new Date())
  const modoDeVisualizacao = ref<ModosDeVisualizacao>("week")
  const termoDeBuscaDoFiltro = ref<string>("")
  const modosDeVisualizacao = [
    { label: t("mes"), valor: "month" },
    { label: t("semana"), valor: "week" },
    { label: t("dia"), valor: "day" },
  ]

  const calendarioRef = ref<InstanceType<typeof OCalendario> | null>()
  const permissionadorTravamento = usarPermissionamento("Travamento")
  const permissionadorEventos = usarPermissionamento("Eventos")

  const fabricarCalendario = (perfil: string): CalendarioInterface => {
    if (perfil === "administrador") {
      return new CalendarioAdministrador()
    } else if (["supervisor", "gerente"].includes(perfil)) {
      return new CalendarioSupervisor()
    } else if (perfil === "visualizador") {
      return new CalendarioVisualizador()
    } else {
      return new CalendarioPessoal()
    }
  }

  const { perfilDeOrganizacao } =
    SessaoServico.coletarInformacoesDoUsuarioLogado()
  const { id: idProfissionalLogado } =
    SessaoServico.coletarInformacoesDeProfissionalDoUsuario()

  const controladorDoCalendario = reactive<CalendarioInterface>(
    fabricarCalendario(perfilDeOrganizacao)
  )

  const home = ref<MenuItem>({
    label: t("atividades"),
    icon: "pi pi-calendar",
    to: "/atividades",
  })

  const { exibirDataPorExtenso, meses, obterTimeZoneLocal } = usarDataHora()

  const { debounceAsync, debounce } = usarDebounces()

  const breadcrumbItems = ref<MenuItem[]>([])

  const acaoDeAtividadePlanejadaEstaCarregando = ref<boolean>(false)

  const iconeBotaoDisplaySidebar = ref<string>("pi-angle-double-right")
  const alternarVisibilidadeSidebar = ref(false)
  const eventoSelecionado = ref<VariacoesModeloEventoCalendario>()

  const dataInicio = ref<Date>(new Date())
  const dataFim = ref<Date>(new Date())

  const modalLancarAtividadeTipo = ref("")
  const modalTravarAtividadeVisivel = ref(false)
  const modalLancarAtividadeVisivel = ref(false)
  const modalIniciarAtividadeNaoPlanejadaVisivel = ref(false)
  const detalhesAtividadeVisivel = ref(false)
  const modalExcluirAtividadeVisivel = ref(false)
  const geradorDeRelatorioVisivel = ref(false)
  const editarPlanejamentoAtividadeVisivel = ref(false)

  const { onErro, onSucesso, onInfo } = usarMensagemUsuario()

  const ehCalendarioAdministrador = (
    objeto: any
  ): objeto is CalendarioAdministrador => {
    return objeto instanceof CalendarioAdministrador
  }

  const ehCalendarioVisualizador = (
    objeto: any
  ): objeto is CalendarioVisualizador => {
    return objeto instanceof CalendarioVisualizador
  }

  const itensBotaoLancarAtividades: MenuItem[] = [
    {
      label: t("lancarAtividades"),
      command: (): void => exibirModalDeLancamento('realizado'),
      visible: !ehCalendarioVisualizador(controladorDoCalendario)
    },
    {
      label: t("lancarAtividadesPlanejadas"),
      command: (): void => exibirModalDeLancamento("planejado"),
      visible: permissionadorEventos.verificarPermissao("criar"),
    },
    {
      label: t("iniciarAtividadeNaoPlanejada"),
      command: (): void => exibirModalDeIniciarAtividadeNaoPlanejada(),
      visible: usuarioPossuiProfissionalAtivo(),
    },
    {
      label: t("travarPeriodo"),
      command: (): void => exibirModalDeTravamento(),
      visible: permissionadorTravamento.verificarPermissao("travar")
    },
  ]

  const itensVisiveisBotaoLancarAtividades = itensBotaoLancarAtividades.filter(
    (item) => item.visible
  )

  const exibirBotaoSplitDeLancarAtividades = computed(() => {
    const totalDeMenusVisiveis = itensVisiveisBotaoLancarAtividades.length > 1

    return totalDeMenusVisiveis
  })

  const exibirABotaoSimplesDeLancarAtividades = computed(() => {
    const totalDeMenusVisiveis = itensVisiveisBotaoLancarAtividades.length === 1

    return totalDeMenusVisiveis
  })


  const modoDeFormularioAtividade = computed(() =>
    eventoSelecionado.value ? "editar" : "criar"
  )

  const eventoSelecionadoEhPlanejado = computed(() => {
    const evento = eventoSelecionado.value
    return evento && evento.status === "planejado"
  })

  const periodoAtual = ref<string>()

  const montarPeriodoDeTempo = (
    dataDeInicio: Date,
    dataDeFim: Date
  ): PeriodoDeTempo => {
    return {
      inicial: {
        dia: dataDeInicio.getDate(),
        mes: dataDeInicio.getMonth(),
        ano: dataDeInicio.getFullYear(),
      },
      final: {
        dia: dataDeFim.getDate(),
        mes: dataDeFim.getMonth(),
        ano: dataDeFim.getFullYear(),
      },
    }
  }

  const formatarLegendaDoPeriodoDeExibicaoDoCalendario = (
    periodo: PeriodoDeTempo
  ): string => {
    const visualizacaoComoDia = "day"
    const modoDeVisualizacaoAtual = modoDeVisualizacao.value

    const {
      dia: diaInicial,
      mes: mesInicial,
      ano: anoInicial
    } = periodo.inicial

    const {
      dia: diaFinal,
      mes: mesFinal
    } = periodo.final

    if (modoDeVisualizacaoAtual === visualizacaoComoDia) {
      return `${meses[mesInicial]} ${diaInicial}, ${anoInicial}`
    }
    return `${meses[mesInicial]} ${diaInicial} - ${meses[mesFinal]} ${diaFinal}, ${anoInicial}`
  }

  const mudarPeriodoExibido = (evento: EventReadyChanged) => {
    const atualizarDatasDoPeriodoSelecionado = (inicio: Date, fim: Date) => {
      dataInicio.value = inicio
      dataFim.value = fim
    }
    const atualizarPeriodoDeFiltragemDeEventosPlanejados = (
      inicio: Date,
      fim: Date
    ) => {
      eventosPlanejadosStore.$patch({
        periodoDeFiltragem: {
          dataInicio: inicio,
          dataFim: fim,
        },
      })
    }
    const periodo = montarPeriodoDeTempo(evento.startDate, evento.endDate)
    atualizarDatasDoPeriodoSelecionado(evento.startDate, evento.endDate)
    atualizarPeriodoDeFiltragemDeEventosPlanejados(
      evento.startDate,
      evento.endDate
    )
    periodoAtual.value = formatarLegendaDoPeriodoDeExibicaoDoCalendario(periodo)

    cancelarRequisicoesEmAndamento()
    buscarCalendarioAtualizarArvoreDeFiltros()
  }

  const obterDetalhesDaAtividadeVisivel = (
    evento: VariacoesModeloEventoCalendario
  ) => {
    eventoSelecionado.value = evento

    if (eventoSelecionado.value) {
      detalhesAtividadeVisivel.value = true
    }
  }

  const exibirModalParaExcluirAtividade = () => {
    modalExcluirAtividadeVisivel.value = true
    detalhesAtividadeVisivel.value = false
  }

  const alternarModalDetalhesAtividade = (
    modalVisivel: boolean,
    modoDeFormularioAtividadeParam: "editar" | "criar"
  ) => {
    detalhesAtividadeVisivel.value =
      !modalVisivel && modoDeFormularioAtividadeParam === "editar"
  }

  const buscarAtividadePorId = (idAtividade: string) => {
    return atividades.value.find((atividade) => atividade.id === idAtividade)
  }

  const abrirGeradorDeRelatorio = () => {
    geradorDeRelatorioVisivel.value = true
  }

  const exibirModalDeTravamento = () => {
    modalTravarAtividadeVisivel.value = true
  }

  const mostrarModalDeEdicaoPlanejamentoAtividade = () => {
    detalhesAtividadeVisivel.value = false
    editarPlanejamentoAtividadeVisivel.value = true
  }

  const exibirModalDeIniciarAtividadeNaoPlanejada = () => {
    modalIniciarAtividadeNaoPlanejadaVisivel.value = true
  }

  const exibirModalDeLancamento = (tipo = "realizado") => {
    modalLancarAtividadeTipo.value = tipo
    eventoSelecionado.value = undefined
    modalLancarAtividadeVisivel.value = true
  }

  const exibirModalDeEditarAtividade = () => {
    modalLancarAtividadeVisivel.value = true
    detalhesAtividadeVisivel.value = false
  }

  const alternarSidebar = async (): Promise<void> => {
    if (iconeBotaoDisplaySidebar.value === "pi-angle-double-left") {
      iconeBotaoDisplaySidebar.value = "pi-angle-double-right"
      alternarVisibilidadeSidebar.value = false
    } else {
      iconeBotaoDisplaySidebar.value = "pi-angle-double-left"
      alternarVisibilidadeSidebar.value = true
    }
  }

  const obterNomeDoProfissional = (profissional: EntidadeGenerica): string => {
    return profissional?.nome || ""
  }

  const desmarcarOcorrenciasEAtualizarCalendario = (
    grupoDeOcorrencias: Ocorrencias
  ) => {
    grupoDeOcorrencias.atividadeMuitoCurta = false
    grupoDeOcorrencias.atividadeMuitoLonga = false
    grupoDeOcorrencias.atividadeNaoPlanejada = false
    atualizarCalendarioLocalmenteDebouncer()
  }

  const desmarcarSemOcorrenciasEAtualizarCalendario = (
    grupoDeOcorrencias: Ocorrencias
  ) => {
    grupoDeOcorrencias.atividadeSemOcorrencias = false
    atualizarCalendarioLocalmenteDebouncer()
  }
  const buscarAtividadesDoCalendarioSemCache = async (): Promise<void> => {
    await buscarAtividadesDoCalendario(
      dataInicio.value,
      dataFim.value,
      NAO_UTILIZAR_CACHE
    )
  }
  const [buscarCalendarioAtualizarArvoreDeFiltros, cancelarBuscaCalendario] =
    debounceAsync<void>(async () => {
      if (controladorDoCalendario.estaAtualizandoCalendario) {
        return
      }

      await buscarAtividadesDoCalendario(dataInicio.value, dataFim.value)

      if (termoDeBuscaDoFiltro.value) {
        filtrarEConstruirArvore(termoDeBuscaDoFiltro.value)
      } else {
        controladorDoCalendario.construirArvoreDeFiltros()
      }
    }, 400)

  const atualizarFiltrosDeProjetoSelecionados = async (
    arrayDeProjetos: string[] | Ref<string[]>
  ): Promise<void> => {
    cancelarRequisicoesEmAndamento()

    limparFiltrosSelecionados()
    limparOcorrencias()

    await buscarAtividadesDoCalendario(
      dataInicio.value,
      dataFim.value,
      UTILIZAR_CACHE
    )

    controladorDoCalendario.construirArvoreDeFiltros()
  }

  const atualizarFiltrosDeProjetosDebouncer = debounce<
    string[] | Ref<string[]>
  >(atualizarFiltrosDeProjetoSelecionados, 500)

  const atualizarFiltrosDeGrupoProjetos = async (
    idGrupoDeProjeto: string
  ): Promise<void> => {
    cancelarRequisicoesEmAndamento()

    limparFiltrosSelecionados()
    limparOcorrencias()

    if (idGrupoDeProjeto === "todos-projetos") {
      await (controladorDoCalendario as unknown as CalendarioAdministrador).buscarProjetos()
    } else {
      await (controladorDoCalendario as unknown as CalendarioAdministrador).buscarProjetos(idGrupoDeProjeto)
    }

    (controladorDoCalendario as unknown as CalendarioAdministrador).selecionarTodosOsProjetos()

    await buscarAtividadesDoCalendario(
      dataInicio.value,
      dataFim.value,
      UTILIZAR_CACHE
    )

    controladorDoCalendario.construirArvoreDeFiltros()
  }

  const atualizarFiltrosSelecionados = (
    itensSelecionados: ChaveValor<string>[]
  ) => {
    const selecionadosDaArvore =
      itensSelecionados as ChaveValor<NomeDosModulos>[]

    filtrosSelecionados.value = selecionadosDaArvore

    controladorDoCalendario.remontarCalendarioLocalmente()
  }

  const atualizarCalendarioLocalmenteDebouncer = debounce<void>(
    controladorDoCalendario.remontarCalendarioLocalmente,
    500
  )

  const cancelarRequisicoesEmAndamento = () => {
    cancelamento.cancelarRequisicoesPendentes()
  }

  const resolverSucessoDaAcaoDeAtividadePlanejada = async () => {
    acaoDeAtividadePlanejadaEstaCarregando.value = false
    detalhesAtividadeVisivel.value = false
    await buscarAtividadesDoCalendarioSemCache()
  }

  const iniciarAtividadePlanejada = async (
    atividade:
      | ModeloEventoCalendarioEmAndamento
      | ModeloEventoCalendarioPodeSerIniciada
  ) => {
    const atividadePlanejadaPossuiAtributos = caracteristicas.value.length > 0

    if (!eventoSelecionado.value) {
      return
    }

    if (!idProfissionalLogado) {
      onErro({
        resumo: t("usuarioNaoPossuiPermissaoParaIniciarAtividade"),
        detalhes: "",
      })
      return
    }

    const argumentos: IniciarAtividadeRealizada = {
      idTipoDeAtividade: atividade.tipoDeAtividade.id,
      idAtividadePlanejada: atividade.id,
      modoDeRegistroInicio: "web",
      idProfissionalQueRealizou: idProfissionalLogado,
      idProjeto: atividade.projeto?.id || null,
      timezone: obterTimeZoneLocal(),
    }

    if (atividadePlanejadaPossuiAtributos) {
      const caracteristicasSemValorPreenchido = !caracteristicas.value.every(caracteristica => verificarSeElementoTemConteudo(caracteristica.valor))

      if (caracteristicasSemValorPreenchido) {
        onInfo({
          resumo: t("atributosComValoresInvalidos"),
          detalhes: t("obrigatorioPreencherAtributos"),
        })
        return
      }
    }

    argumentos.listaDeAtributosCaracteristicaComValor = caracteristicas.value.map(caracteristica => ({
      id: caracteristica.id,
      valor: caracteristica.valor,
    }))

    escritorIniciarAtividadePlanejada.mudarArgumentos([argumentos])
    await escritorIniciarAtividadePlanejada.executar()

    resolver(escritorIniciarAtividadePlanejada.resultado, {
      sucesso: async () => {
        onSucesso({
          resumo: t("atividadeIniciadaComSucesso"),
          detalhes: t("calendarioEstaSendoAtualizado"),
        })
        await resolverSucessoDaAcaoDeAtividadePlanejada()
      },
      erro: (erro: any) => {
        onErro({
          resumo: t("ocorreuUmErroAoIniciarAtividade"),
          detalhes: erro.detalhe,
        })
        acaoDeAtividadePlanejadaEstaCarregando.value = false
      },
    })
  }

  const finalizarAtividadePlanejada = async (idAtividade: string) => {
    const argumentos: FinalizarAtividadePlanejada = {
      modoDeRegistroFim: "web",
      justificativas: [],
      timezone: obterTimeZoneLocal(),
    }

    escritorFinalizarAtividadePlanejada.mudarArgumentos([
      idAtividade,
      argumentos,
    ])
    await escritorFinalizarAtividadePlanejada.executar()

    resolver(escritorFinalizarAtividadePlanejada.resultado, {
      sucesso: async () => {
        onSucesso({
          resumo: t("atividadeFinalizadaComSucesso"),
          detalhes: t("calendarioEstaSendoAtualizado"),
        })
        await resolverSucessoDaAcaoDeAtividadePlanejada()
      },
      erro: (erro: any) => {
        onErro({
          resumo: t("ocorreuUmErroAoFinalizarAtividade"),
          detalhes: erro.detalhe || t("tenteNovamenteMaisTarde"),
        })
        acaoDeAtividadePlanejadaEstaCarregando.value = false
      },
    })
  }

  const filtrarEConstruirArvore = async (termo: string): Promise<void> => {
    await filtrarDadosDoCalendario(termo)
    controladorDoCalendario.construirArvoreDeFiltros()
  }

  const filtrarFiltrosDoCalendarioPorTermoDeBusca = debounce(
    filtrarEConstruirArvore,
    400
  )

  const buscarAtividadesDoCalendario = async (
    dataInicial: Date,
    dataFinal: Date,
    utilizaCache = true
  ): Promise<void> => {
    try {
      await controladorDoCalendario.remontarCalendario(
        dataInicial,
        dataFinal,
        utilizaCache
      )
    } catch (erro) {
      onErro({
        resumo: t("ocorreuUmErroAoCarregarCalendario"),
        detalhes: t("tenteNovamenteMaisTarde")
      })
    }
  }

  watch(atividades, () => {
    if (eventoSelecionado.value) {
      eventoSelecionado.value = buscarAtividadePorId(eventoSelecionado.value.id)
    }
  })

  watch(editarPlanejamentoAtividadeVisivel, (visivel) => {
    if (!visivel) {
      editarPlanejamentoAtividadeVisivel.value = false
      detalhesAtividadeVisivel.value = true
    }
  })

  watch(modalLancarAtividadeVisivel, (modalVisivel) => {
    alternarModalDetalhesAtividade(
      modalVisivel,
      modoDeFormularioAtividade.value
    )
  })

  watch(modalExcluirAtividadeVisivel, (modalVisivel) => {
    alternarModalDetalhesAtividade(
      modalVisivel,
      modoDeFormularioAtividade.value
    )
  })

  onBeforeMount(async () => {
    try {
      await controladorDoCalendario.inicializarCalendario()
    } catch (erro: any) {
      onErro({
        resumo: erro?.message || t("ocorreuUmErroAoCarregarCalendario"),
        detalhes: t("tenteNovamenteMaisTarde"),
      })
    }
  })

  onUnmounted(() => {
    cancelarBuscaCalendario()
    limparAtividades()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LCalendario), { "data-testid": "Atividades" }, {
    default: _withCtx(() => [
      _createVNode(_unref(TAtividades), { "exibir-sidebar": alternarVisibilidadeSidebar.value }, {
        navegacao: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(PButton), {
              onClick: alternarSidebar,
              class: "TAtividades__Interruptor p-button-rounded p-button-text",
              "data-testid": "TAtividades__Interruptor",
              icon: 'pi ' + iconeBotaoDisplaySidebar.value
            }, null, 8, ["icon"]),
            _createVNode(_unref(OTrilhaDeNavegacao), {
              class: "TAtividades__BreadCrumb",
              "inicio-da-trilha": home.value,
              "itens-da-trilha": breadcrumbItems.value
            }, null, 8, ["inicio-da-trilha", "itens-da-trilha"]),
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_unref(PButton), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (calendarioRef.value?.anterior())),
                class: "CalendarioDeAtividades__Anterior",
                icon: "pi pi-angle-left"
              }),
              _createVNode(_unref(PButton), {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (calendarioRef.value?.proxima())),
                class: "CalendarioDeAtividades__Proxima",
                icon: "pi pi-angle-right",
                "icon-pos": "right"
              })
            ]),
            _createVNode(_unref(PButton), {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (calendarioRef.value?.hoje())),
              class: "CalendarioDeAtividades__Hoje",
              label: _unref(t)('hoje')
            }, null, 8, ["label"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", null, _toDisplayString(periodoAtual.value), 1)
            ]),
            _createVNode(_unref(Dropdown), {
              modelValue: modoDeVisualizacao.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modoDeVisualizacao).value = $event)),
              class: "CalendarioDeAtvidades__DropdownVisualizador",
              "data-testid": "CalendarioDeAtvidades__DropdownVisualizador",
              "option-label": "label",
              "option-value": "valor",
              options: modosDeVisualizacao
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (
              ehCalendarioAdministrador(controladorDoCalendario) ||
                ehCalendarioVisualizador(controladorDoCalendario)
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_unref(MDropdown), {
                    modelValue: controladorDoCalendario.grupoDeProjetoSelecionado,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((controladorDoCalendario.grupoDeProjetoSelecionado) = $event)),
                      atualizarFiltrosDeGrupoProjetos
                    ],
                    "buscar-mais-itens": 
                controladorDoCalendario.buscarMaisGruposDeProjetos
              ,
                    carregando: 
                controladorDoCalendario.estaCarregandoGruposDeProjetos
              ,
                    class: "TAtividades__SeletorGrupos",
                    "data-testid": "TAtividades__SeletorGrupos",
                    "option-label": "nome",
                    "option-value": "id",
                    options: controladorDoCalendario.gruposDeProjetos,
                    placeholder: _unref(t)('gruposDeProjetos'),
                    "usar-carregamento-sob-demanda": "",
                    width: "544px"
                  }, null, 8, ["modelValue", "buscar-mais-itens", "carregando", "options", "placeholder"])
                ]))
              : _createCommentVNode("", true),
            (
              ehCalendarioAdministrador(controladorDoCalendario) ||
                ehCalendarioVisualizador(controladorDoCalendario)
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_unref(MMultiSelect), {
                    modelValue: controladorDoCalendario.projetosSelecionados,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((controladorDoCalendario.projetosSelecionados) = $event)),
                      _unref(atualizarFiltrosDeProjetosDebouncer)
                    ],
                    carregando: _unref(estaCarregandoProjetos),
                    class: "TAtividades__MMultiselect",
                    "data-testid": "TAtividades__MMultiselect",
                    "exibicao-de-opcoes": "comma",
                    "legenda-maximo-selecionados": `{0} ${_unref(t)('projetosSelecionados')}`,
                    "maximo-de-legendas-selecionadas": 1,
                    nome: "projetos",
                    "option-label": "nome",
                    "option-value": "id",
                    options: _unref(projetos),
                    placeholder: _unref(t)('projetos'),
                    width: "544px"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "carregando", "legenda-maximo-selecionados", "options", "placeholder"])
                ]))
              : _createCommentVNode("", true),
            (ehCalendarioAdministrador(controladorDoCalendario) && !ehCalendarioVisualizador(controladorDoCalendario))
              ? (_openBlock(), _createBlock(_unref(PButton), {
                  key: 2,
                  onClick: abrirGeradorDeRelatorio,
                  class: "TAtividades__GerarRelatorio",
                  "data-testid": "TAtividades__GerarRelatorio",
                  icon: "pi pi-download"
                }))
              : _createCommentVNode("", true),
            (_unref(exibirBotaoSplitDeLancarAtividades))
              ? (_openBlock(), _createBlock(_unref(SplitButton), {
                  key: 3,
                  onClick: _unref(itensVisiveisBotaoLancarAtividades)[0].command,
                  class: "CalendarioDeAtvidades__BotaoAcoesMultiplas p-button-warning",
                  "data-testid": "Atividades__SplitButtonLancarAtividades",
                  label: _unref(itensVisiveisBotaoLancarAtividades)[0].label,
                  model: _unref(itensVisiveisBotaoLancarAtividades).slice(1)
                }, null, 8, ["onClick", "label", "model"]))
              : (_unref(exibirABotaoSimplesDeLancarAtividades))
                ? (_openBlock(), _createBlock(_unref(PButton), {
                    key: 4,
                    onClick: _unref(itensVisiveisBotaoLancarAtividades)[0].command,
                    class: "p-button-warning",
                    "data-testid": "Atividades__ButtonLancarAtividades",
                    label: _unref(itensVisiveisBotaoLancarAtividades)[0].label
                  }, null, 8, ["onClick", "label"]))
                : _createCommentVNode("", true)
          ])
        ]),
        sidebar: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_unref(TabMenu), {
              activeIndex: indexAtivo.value,
              "onUpdate:activeIndex": _cache[6] || (_cache[6] = ($event: any) => ((indexAtivo).value = $event)),
              class: "CalendarioDeAtividades__TabMenu",
              "data-testid": "CalendarioDeAtividades__TabMenu",
              model: itensTabMenu
            }, null, 8, ["activeIndex"]),
            _withDirectives(_createVNode(_unref(MEntradaDeBusca), {
              modelValue: termoDeBuscaDoFiltro.value,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((termoDeBuscaDoFiltro).value = $event)),
                _cache[8] || (_cache[8] = ($event: any) => (
              _unref(filtrarFiltrosDoCalendarioPorTermoDeBusca)($event as string)
            ))
              ],
              class: "CalendarioDeAtividades__EntradaDeFiltro",
              desabilitado: controladorDoCalendario.estaAtualizandoCalendario
            }, null, 8, ["modelValue", "desabilitado"]), [
              [_vShow, indexAtivo.value === 0]
            ]),
            (indexAtivo.value === 0)
              ? (_openBlock(), _createBlock(_unref(OArvoreDeSelecoes), {
                  key: 0,
                  "onAtualizar:selecionados": atualizarFiltrosSelecionados,
                  "esta-carregando": controladorDoCalendario.estaAtualizandoCalendario,
                  nos: controladorDoCalendario.arvoreDeFiltros,
                  selecionados: _unref(filtrosSelecionados)
                }, null, 8, ["esta-carregando", "nos", "selecionados"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(MCheckbox), {
                    modelValue: _unref(ocorrencias).atividadeMuitoLonga,
                    "onUpdate:modelValue": [
                      _cache[9] || (_cache[9] = ($event: any) => ((_unref(ocorrencias).atividadeMuitoLonga) = $event)),
                      _cache[10] || (_cache[10] = ($event: any) => (
                    desmarcarSemOcorrenciasEAtualizarCalendario(_unref(ocorrencias))
                  ))
                    ],
                    binary: true,
                    class: "Ocorrencias__Checkbox",
                    "data-testid": "checkbox-atividade-muito-longa",
                    label: _unref(t)('atividadeMuitoLonga'),
                    nome: "checkbox-atividade-muito-longa"
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(_unref(MCheckbox), {
                    modelValue: _unref(ocorrencias).atividadeMuitoCurta,
                    "onUpdate:modelValue": [
                      _cache[11] || (_cache[11] = ($event: any) => ((_unref(ocorrencias).atividadeMuitoCurta) = $event)),
                      _cache[12] || (_cache[12] = ($event: any) => (
                    desmarcarSemOcorrenciasEAtualizarCalendario(_unref(ocorrencias))
                  ))
                    ],
                    binary: true,
                    class: "Ocorrencias__Checkbox",
                    "data-testid": "checkbox-atividade-muito-curta",
                    label: _unref(t)('atividadeMuitoCurta'),
                    nome: "checkbox-atividade-muito-curta"
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(_unref(MCheckbox), {
                    modelValue: _unref(ocorrencias).atividadeNaoPlanejada,
                    "onUpdate:modelValue": [
                      _cache[13] || (_cache[13] = ($event: any) => ((_unref(ocorrencias).atividadeNaoPlanejada) = $event)),
                      _cache[14] || (_cache[14] = ($event: any) => (
                    desmarcarSemOcorrenciasEAtualizarCalendario(_unref(ocorrencias))
                  ))
                    ],
                    binary: true,
                    class: "Ocorrencias__Checkbox",
                    "data-testid": "checkbox-atividade-nao-planejada",
                    label: _unref(t)('atividadeNaoPlanejada'),
                    nome: "checkbox-atividade-nao-planejada"
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_unref(MCheckbox), {
                    modelValue: _unref(ocorrencias).atividadeSemOcorrencias,
                    "onUpdate:modelValue": [
                      _cache[15] || (_cache[15] = ($event: any) => ((_unref(ocorrencias).atividadeSemOcorrencias) = $event)),
                      _cache[16] || (_cache[16] = ($event: any) => (
                    desmarcarOcorrenciasEAtualizarCalendario(_unref(ocorrencias))
                  ))
                    ],
                    binary: true,
                    class: "Ocorrencias__Checkbox",
                    "data-testid": "checkbox-atividade-sem-ocorrencias",
                    label: _unref(t)('atividadeSemOcorrencias'),
                    nome: "checkbox-atividade-sem-ocorrencias"
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", null, [
                    _hoisted_13,
                    _createTextVNode(_toDisplayString(_unref(t)('filtroDeOcorrenciasLeganda1')), 1)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('filtroDeOcorrenciasLeganda2')), 1)
                ])
              ])
            ], 512), [
              [_vShow, indexAtivo.value === 1]
            ])
          ])
        ]),
        centro: _withCtx(() => [
          _createVNode(_unref(OCalendario), {
            "active-view": modoDeVisualizacao.value,
            "onUpdate:active-view": _cache[17] || (_cache[17] = ($event: any) => ((modoDeVisualizacao).value = $event)),
            "selected-date": dataAtual.value,
            "onUpdate:selected-date": _cache[18] || (_cache[18] = ($event: any) => ((dataAtual).value = $event)),
            onOnCalendarioPronto: mudarPeriodoExibido,
            onOnExibirDetalhesAtividade: obterDetalhesDaAtividadeVisivel,
            onOnMudarPeriodo: mudarPeriodoExibido,
            ref_key: "calendarioRef",
            ref: calendarioRef,
            "data-testid": "TAtividades__Calendario",
            "esta-carregando": controladorDoCalendario.estaAtualizandoCalendario
          }, null, 8, ["active-view", "selected-date", "esta-carregando"])
        ]),
        modais: _withCtx(() => [
          (modalTravarAtividadeVisivel.value)
            ? (_openBlock(), _createBlock(_unref(OTravarPeriodo), {
                key: 0,
                visible: modalTravarAtividadeVisivel.value,
                "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((modalTravarAtividadeVisivel).value = $event)),
                onPeriodoTravado: buscarAtividadesDoCalendarioSemCache,
                "data-testid": "Atividades__TravarEvento",
                destinos: __props.destinoModal
              }, null, 8, ["visible", "destinos"]))
            : _createCommentVNode("", true),
          (modalIniciarAtividadeNaoPlanejadaVisivel.value)
            ? (_openBlock(), _createBlock(_unref(OIniciarAtividadeRealizadaNaoPlanejada), {
                key: 1,
                visibilidade: modalIniciarAtividadeNaoPlanejadaVisivel.value,
                "onUpdate:visibilidade": _cache[20] || (_cache[20] = ($event: any) => ((modalIniciarAtividadeNaoPlanejadaVisivel).value = $event)),
                "onUpdate:atualizarCalendario": buscarAtividadesDoCalendarioSemCache
              }, null, 8, ["visibilidade"]))
            : _createCommentVNode("", true),
          (
            modalLancarAtividadeVisivel.value &&
              (modalLancarAtividadeTipo.value === 'planejado' ||
                _unref(eventoSelecionadoEhPlanejado))
          )
            ? (_openBlock(), _createBlock(_unref(OCriarEventoPlanejado), {
                key: 2,
                visible: modalLancarAtividadeVisivel.value,
                "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((modalLancarAtividadeVisivel).value = $event)),
                onOnRecarregarAtividades: buscarAtividadesDoCalendarioSemCache,
                "data-testid": "Atividades__LancarEvento",
                destinos: __props.destinoModal,
                "id-evento": eventoSelecionado.value?.id,
                modo: _unref(modoDeFormularioAtividade),
                "lista-de-atributos-caracteristica-com-valor": eventoSelecionado.value?.listaDeAtributosCaracteristicaComValor
              }, null, 8, ["visible", "destinos", "id-evento", "modo", "lista-de-atributos-caracteristica-com-valor"]))
            : (
            modalLancarAtividadeVisivel.value && !_unref(eventoSelecionadoEhPlanejado)
          )
              ? (_openBlock(), _createBlock(_unref(OCriarEvento), {
                  key: 3,
                  visible: modalLancarAtividadeVisivel.value,
                  "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((modalLancarAtividadeVisivel).value = $event)),
                  onOnRecarregarAtividades: buscarAtividadesDoCalendarioSemCache,
                  "data-testid": "Atividades__LancarEvento",
                  destinos: __props.destinoModal,
                  "id-evento": eventoSelecionado.value?.id,
                  "lista-de-atributos-caracteristica-com-valor": eventoSelecionado.value?.listaDeAtributosCaracteristicaComValor,
                  modo: _unref(modoDeFormularioAtividade)
                }, null, 8, ["visible", "destinos", "id-evento", "lista-de-atributos-caracteristica-com-valor", "modo"]))
              : _createCommentVNode("", true),
          (detalhesAtividadeVisivel.value && eventoSelecionado.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (_unref(eventoSelecionadoEhPlanejado))
                  ? (_openBlock(), _createBlock(_unref(ODetalhesEventoPlanejado), {
                      key: 0,
                      visibilidade: detalhesAtividadeVisivel.value,
                      "onUpdate:visibilidade": _cache[23] || (_cache[23] = ($event: any) => ((detalhesAtividadeVisivel).value = $event)),
                      onAoExibirModalDeEdicaoPlanejamento: 
              mostrarModalDeEdicaoPlanejamentoAtividade
            ,
                      onFinalizarAtividade: _cache[24] || (_cache[24] = ($event: any) => (
              finalizarAtividadePlanejada(eventoSelecionado.value.id)
            )),
                      onIniciarAtividade: _cache[25] || (_cache[25] = ($event: any) => (
              iniciarAtividadePlanejada(
                eventoSelecionado.value as ModeloEventoCalendarioEmAndamento
              )
            )),
                      onOnRecarregarAtividades: buscarAtividadesDoCalendarioSemCache,
                      "acao-iniciando-ou-finalizando-atividade": 
              acaoDeAtividadePlanejadaEstaCarregando.value
            ,
                      "atividade-recorrente": !!eventoSelecionado.value.calendario,
                      "calendario-id": eventoSelecionado.value.calendario,
                      "duracao-em-minutos": eventoSelecionado.value.duracao!,
                      "evento-id": eventoSelecionado.value.id,
                      "fase-da-atividade": eventoSelecionado.value?.faseDaAtividade,
                      fim: eventoSelecionado.value.end,
                      "fim-planejado": (eventoSelecionado.value as ModeloEventoCalendarioEmAndamento).fimPlanejado,
                      inicio: eventoSelecionado.value.start,
                      "inicio-planejado": (eventoSelecionado.value as ModeloEventoCalendarioEmAndamento).inicioPlanejado,
                      "nome-atividade": eventoSelecionado.value.tipoDeAtividade.nome,
                      "atributos-esperados": eventoSelecionado.value.tipoDeAtividade.atributosEsperados,
                      "lista-de-atributos-caracteristica-com-valor": eventoSelecionado.value.listaDeAtributosCaracteristicaComValor,
                      "nome-projeto": eventoSelecionado.value.projeto?.nome,
                      profissionais: eventoSelecionado.value.profissionais,
                      "projeto-id": eventoSelecionado.value.projeto?.id,
                      "teleportar-para": __props.destinoModal
                    }, null, 8, ["visibilidade", "onAoExibirModalDeEdicaoPlanejamento", "acao-iniciando-ou-finalizando-atividade", "atividade-recorrente", "calendario-id", "duracao-em-minutos", "evento-id", "fase-da-atividade", "fim", "fim-planejado", "inicio", "inicio-planejado", "nome-atividade", "atributos-esperados", "lista-de-atributos-caracteristica-com-valor", "nome-projeto", "profissionais", "projeto-id", "teleportar-para"]))
                  : (eventoSelecionado.value && !_unref(eventoSelecionadoEhPlanejado))
                    ? (_openBlock(), _createBlock(_unref(ODetalhesEvento), {
                        key: 1,
                        visible: detalhesAtividadeVisivel.value,
                        "onUpdate:visible": _cache[26] || (_cache[26] = ($event: any) => ((detalhesAtividadeVisivel).value = $event)),
                        onFinalizarAtividade: _cache[27] || (_cache[27] = ($event: any) => (
              finalizarAtividadePlanejada(eventoSelecionado.value.id)
            )),
                        onIniciarAtividade: _cache[28] || (_cache[28] = ($event: any) => (
              iniciarAtividadePlanejada(
                eventoSelecionado.value as ModeloEventoCalendarioEmAndamento
              )
            )),
                        onOnExibirModalDeEditarAtividade: exibirModalDeEditarAtividade,
                        onOnExibirModalDeExcluirAtividade: 
              exibirModalParaExcluirAtividade
            ,
                        id: eventoSelecionado.value.id,
                        "acao-iniciando-ou-finalizando-atividade": 
              acaoDeAtividadePlanejadaEstaCarregando.value
            ,
                        "data-testid": "Atividades__Detalhes",
                        "fase-da-atividade": eventoSelecionado.value?.faseDaAtividade,
                        fim: eventoSelecionado.value.end,
                        "id-projeto": eventoSelecionado.value.projeto?.id,
                        "id-tipo-de-atividade": eventoSelecionado.value.tipoDeAtividade.id,
                        "id-usuario-criador": eventoSelecionado.value.idUsuarioCriador,
                        inicio: eventoSelecionado.value.start,
                        "modo-de-registro-fim": eventoSelecionado.value.modoDeRegistroFim,
                        "modo-de-registro-inicio": eventoSelecionado.value.modoDeRegistroInicio!,
                        "nome-atividade": eventoSelecionado.value.tipoDeAtividade.nome,
                        "lista-de-atributos-caracteristica-com-valor": eventoSelecionado.value.listaDeAtributosCaracteristicaComValor,
                        problemas: eventoSelecionado.value.problemas,
                        profissional: eventoSelecionado.value.profissionais[0],
                        projeto: eventoSelecionado.value.projeto?.nome,
                        status: eventoSelecionado.value.status
                      }, null, 8, ["visible", "onOnExibirModalDeExcluirAtividade", "id", "acao-iniciando-ou-finalizando-atividade", "fase-da-atividade", "fim", "id-projeto", "id-tipo-de-atividade", "id-usuario-criador", "inicio", "modo-de-registro-fim", "modo-de-registro-inicio", "nome-atividade", "lista-de-atributos-caracteristica-com-valor", "problemas", "profissional", "projeto", "status"]))
                    : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (
            eventoSelecionado.value &&
              eventoSelecionado.value.profissionais &&
              modalExcluirAtividadeVisivel.value
          )
            ? (_openBlock(), _createBlock(_unref(OModalExcluirAtividade), {
                key: 5,
                modelValue: modalExcluirAtividadeVisivel.value,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((modalExcluirAtividadeVisivel).value = $event)),
                onOnRecarregarAtividades: buscarAtividadesDoCalendarioSemCache,
                class: "ODetalhesEvento__ModalExcluir",
                "data-por-extenso-fim": _unref(exibirDataPorExtenso)(eventoSelecionado.value.end),
                "data-por-extenso-inicio": 
            _unref(exibirDataPorExtenso)(eventoSelecionado.value.start)
          ,
                "data-testid": "ODetalhesEvento__ModalExcluir",
                "id-do-evento": eventoSelecionado.value.id,
                "modo-de-registro": eventoSelecionado.value.modoDeRegistroInicio!,
                "nome-atividade": eventoSelecionado.value.tipoDeAtividade.nome,
                "nome-profissional": 
            obterNomeDoProfissional(eventoSelecionado.value.profissionais[0])
          
              }, null, 8, ["modelValue", "data-por-extenso-fim", "data-por-extenso-inicio", "id-do-evento", "modo-de-registro", "nome-atividade", "nome-profissional"]))
            : _createCommentVNode("", true),
          (geradorDeRelatorioVisivel.value)
            ? (_openBlock(), _createBlock(_unref(OCriarRelatorioAtividades), {
                key: 6,
                visible: geradorDeRelatorioVisivel.value,
                "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => ((geradorDeRelatorioVisivel).value = $event)),
                "data-testid": "TAtividades__CriarRelatorio",
                "teleportar-para": __props.destinoModal
              }, null, 8, ["visible", "teleportar-para"]))
            : _createCommentVNode("", true),
          (editarPlanejamentoAtividadeVisivel.value)
            ? (_openBlock(), _createBlock(_unref(OEditarPlanejamentoAtividade), {
                key: 7,
                visibilidade: editarPlanejamentoAtividadeVisivel.value,
                "onUpdate:visibilidade": _cache[31] || (_cache[31] = ($event: any) => ((editarPlanejamentoAtividadeVisivel).value = $event)),
                onOnRecarregarAtividades: buscarAtividadesDoCalendarioSemCache,
                "codigo-atividade": eventoSelecionado.value?.atividade?.codigo!,
                "data-hora-fim-evento": (eventoSelecionado.value?.end as Date),
                "data-hora-inicio-evento": (eventoSelecionado.value?.start as Date),
                "duracao-em-minutos-do-evento": eventoSelecionado.value?.duracao!,
                "id-atividade-planejada": eventoSelecionado.value?.atividade?.id!,
                "id-calendario": eventoSelecionado.value?.calendario,
                "id-evento-atividade-planejada": eventoSelecionado.value?.id!,
                "nome-atividade": eventoSelecionado.value?.tipoDeAtividade.nome!,
                "nome-projeto": eventoSelecionado.value?.projeto?.nome,
                "profissionais-alocados": eventoSelecionado.value?.profissionais,
                "atributos-esperados": eventoSelecionado.value?.tipoDeAtividade.atributosEsperados
              }, null, 8, ["visibilidade", "codigo-atividade", "data-hora-fim-evento", "data-hora-inicio-evento", "duracao-em-minutos-do-evento", "id-atividade-planejada", "id-calendario", "id-evento-atividade-planejada", "nome-atividade", "nome-projeto", "profissionais-alocados", "atributos-esperados"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["exibir-sidebar"])
    ]),
    _: 1
  }))
}
}

})